module.exports = __webpack_public_path__ + "static/media/tab_pin_icon_active.bd2cc326.svg";